import type { BaseActionStore } from './types';

const initialState: BaseActionStore = {
  actions: [],
  errorActions: [],
  successActions: [],
};

export default initialState;
